/******************************************************************************************
 *	Customer Invitations
 *******************************************************************************************/
(function() {
  

  angular.module('rcServices.customerInvitation', []).service(
    'CustomerInvitation',
    /* @ngInject */
    function($q, DemoMode, jilResellerCustomers, MiniJil, User) {
      //Update invitation email
      this.updateEmail = function(customerId, payload) {
        if (DemoMode.isEnabled()) {
          const data = MiniJil.updateInvitation(customerId, payload);
          if (data) {
            return $q.resolve(data);
          } else {
            return $q.reject({
              data: {},
              status: 404
            });
          }
        } else {
          return jilResellerCustomers.customerInvitations.update(
            {
              customerId,
              resellerId: User.getResellerID()
            },
            payload
          ).$promise;
        }
      };

      //Remove invitation
      this.cancel = function(customerId) {
        if (DemoMode.isEnabled()) {
          const data = MiniJil.cancelInvitation(customerId);
          if (data) {
            return $q.resolve(data);
          } else {
            return $q.reject({
              data: {},
              status: 400
            });
          }
        } else {
          return jilResellerCustomers.customerInvitations.delete({
            customerId,
            resellerId: User.getResellerID()
          }).$promise;
        }
      };
    }
  );
})();
